import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Shipping & Delivery Policy</h1>

      <p>
        At <strong>Armani Makhana Company</strong>, we are committed to delivering our
        premium apparel safely and on time. Please review our shipping policy to
        understand how your order will be processed and delivered.
      </p>

      <h2>1. Order Processing</h2>
      <p>
        All orders are processed within <strong>1–2 business days</strong> after
        successful payment confirmation. Orders placed on weekends or public
        holidays will be processed on the next working day.
      </p>

      <h2>2. Delivery Areas</h2>
      <p>
        We currently ship across India. If your delivery location is
        unserviceable, our team will notify you promptly and issue a full refund
        if necessary.
      </p>

      <h2>3. Estimated Delivery Time</h2>
      <ul>
        <li>
          <strong>Metro Cities:</strong> 2–5 business days
        </li>
        <li>
          <strong>Tier 2/3 Cities:</strong> 4–7 business days
        </li>
        <li>
          <strong>Remote Areas:</strong> 7–10 business days
        </li>
      </ul>
      <p>
        Please note: Delivery times may vary depending on courier availability,
        festive seasons, or other logistical challenges.
      </p>

      <h2>4. Shipping Charges</h2>
      <p>
        Shipping charges are calculated based on order value, weight, and
        delivery location. Final shipping costs will be displayed at checkout
        before you make payment.
      </p>

      <h2>5. Tracking Your Order</h2>
      <p>
        Once your order is dispatched, we will share a tracking ID via email or
        SMS. You can use this ID to track your shipment through our courier
        partner’s tracking portal.
      </p>

      <h2>6. Delays & Exceptions</h2>
      <p>
        While we strive for timely delivery, delays may occur due to factors
        beyond our control such as weather, strikes, or courier delays. In such
        cases, we will keep you informed and work with our logistics partners to
        resolve the issue.
      </p>

      <h2>7. Damaged or Lost Packages</h2>
      <p>
        If your package arrives damaged, tampered with, or if the shipment is
        lost in transit, please contact us immediately. After verification, we
        will either replace the order or issue a refund.
      </p>

      <h2>8. Change of Address</h2>
      <p>
        You may request an address change before the order has been dispatched.
        Once shipped, we may not be able to modify the delivery address. Please
        ensure your details are accurate during checkout.
      </p>

      <h2>9. Support</h2>
      <p>
        For any queries or concerns regarding shipping and delivery, please
        contact us:
      </p>
      <ul>
        <li>
          <strong>Phone:</strong> 7977508283
        </li>
        <li>
          <strong>Email:</strong> armanienterpriises@gmail.com
        </li>
        <li>
          <strong>Address:</strong> Mumbai, MH - 400067, India
        </li>
      </ul>
    </div>
  );
};

export default ShippingPolicy;
